export const STORAGE_KEYS = {
  ADEPT_PROVIDER: 'adept-provider',
  ADEPT_EXTRACTION_USER: 'adept-extraction-user',
  ADEPT_EXTRACTION_USER_SETTINGS: 'adept-extraction-user-settings'
};

export const getStorage = (key: string) => {
  try {
    return JSON.parse(window.localStorage.getItem(key) || '');
  } catch (e) {
    return window.localStorage.getItem(key);
  }
};

export const removeStorage = (key:string) => window.localStorage.removeItem(key);

export const setStorage = (key:string, val:any) => {
  if (typeof val === 'object') {
    val = JSON.stringify(val);
  }

  return window.localStorage.setItem(key, val);
};

export const getUserSettings = () => (
    getStorage(STORAGE_KEYS.ADEPT_EXTRACTION_USER_SETTINGS)
);

export const getUserToken = () => (
    getStorage(STORAGE_KEYS.ADEPT_EXTRACTION_USER)
);

export const setUserToken = (token:string) => (
  // return setStorage(STORAGE_KEYS.ADEPT_EXTRACTION_USER, 'a0f571627a2540e5b8ad8705b54839d7');
   setStorage(STORAGE_KEYS.ADEPT_EXTRACTION_USER, token)
);

export const removeUserToken = () => (
   removeStorage(STORAGE_KEYS.ADEPT_EXTRACTION_USER)
);

export default {
  STORAGE_KEYS,
  getStorage,
  getUserToken,
  getUserSettings,
  removeStorage,
  removeUserToken,
  setStorage,
  setUserToken
};
